import { gsap } from 'gsap';
import { scrollToAnchor } from '../../utils';

export default {
	name: 'default',
	leave({ current, next, trigger }) {
		return new Promise((resolve) => {
			gsap.to(current.container, {
				opacity: 0,
				ease: 'none',
				duration: 0.5,
				onComplete: () => {
					resolve();
				},
			});
		});
	},
	afterLeave({ current, next, trigger }) {
		window.scrollTo(0, 0);

		gsap.set(current.container, {
			position: 'absolute',
			top: 0,
			left: 0,
			width: '100%',
		});

		gsap.set(next.container, {
			opacity: 0,
		});
	},
	enter({ current, next, trigger }) {
		scrollToAnchor(trigger, next.container);

		return new Promise((resolve) => {
			gsap.to(next.container, {
				opacity: 1,
				ease: 'none',
				duration: 0.5,
				onComplete: () => {
					resolve();
				},
			});
		});
	},
};
